import { axiosConfig } from './axios-config.js'

export const article = {
  // 取得文章分類
  getCategory: (id, token) => axiosConfig.get(`/api/console/article-category/${id}`, token),

  // 創建文章分類
  createCategory: (data, token) => axiosConfig.post('/api/console/article-category', data, token),

  // 創建文章分類
  updateCategory: (id, data, token) => axiosConfig.patch(`/api/console/article-category/${id}`, data, token),

  // 刪除文章分類
  deleteCategory: (id, token) => axiosConfig.delete(`/api/console/article-category/${id}`, token),

  // 取得文章
  get: (id, token) => axiosConfig.get(`/api/console/article/${id}`, token),

  // 創建文章
  create: (data, token) => axiosConfig.post('/api/console/article', data, token),

  // 更新文章
  update: (id, data, token) => axiosConfig.patch(`/api/console/article/${id}`, data, token),

  // 更新文章
  delete: (id, token) => axiosConfig.delete(`/api/console/article/${id}`, token)
}
